// extracted by mini-css-extract-plugin
export default {"h3":"style_h3__pzZ8Y"};